/* import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './lang/en.json'
import { themeConfig } from 'configs/theme.config'

const resources = {
    en: {
        translation: en
    },
}

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: themeConfig.locale,
    lng: themeConfig.locale,
    interpolation: {
        escapeValue: false 
    }
})

export const dateLocales = {
    en: () => import('dayjs/locale/en'),
}

export default i18n */

// index.js - Configuración base de i18n
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './lang/en.json'
import { themeConfig } from 'configs/theme.config'

const resources = {
    en: {
        translation: en
    },
}

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: themeConfig.locale,
    lng: themeConfig.locale,
    interpolation: {
        escapeValue: false 
    }
})

export const dateLocales = {
    en: () => import('dayjs/locale/en'),
}

// Función para actualizar traducciones dinámicas
export const updateDynamicTranslations = (parametersData) => {
    const dynamicTranslations = {}
    
    // Extraer todas las claves que empiecen con 'label_'
    Object.keys(parametersData).forEach(key => {
        if (key.startsWith('label_')) {
            // Remover el prefijo 'label_' para la clave de traducción
            const translationKey = key.replace('label_', '')
            dynamicTranslations[translationKey] = parametersData[key]
        }
    })
    
    // Agregar las traducciones dinámicas al namespace actual
    i18n.addResourceBundle(
        i18n.language, // idioma actual
        'translation', // namespace
        dynamicTranslations, // nuevas traducciones
        true, // deep merge
        true // overwrite
    )
}

export default i18n

